.fallback {
  border-inline-start: 3px solid var(--danger);
  background: var(--bg);
  border-radius: 0;
  border-start-end-radius: var(--radius-s);
  border-end-end-radius: var(--radius-s);
  padding: 8px 12px;
  font-size: 14px;
  display: flex;
  flex-wrap: wrap;
  align-items: center;
  gap: 8px 14px;
}
.fallback p {
  margin: 0;
}
.fallback button {
  font: 600 12px var(--font-mono);
  border: 1px solid var(--line);
  background: var(--surface);
  border-radius: var(--radius-s);
  padding: 5px 10px;
  cursor: pointer;
}
